import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import CreateIcon from "@mui/icons-material/Create";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AppliancesDeleteModal from "./AppliancesDeleteModal";
import moment from "moment";
import { errorToast } from "../../common/ToastMessage";
import Loader from "../../common/Loader";


function Appliances() {
  const navigate = useNavigate();
  const [appliance, setAppliance] = useState();
  const [openmodel, setOpenModel] = useState(false);
  const [applianceid, setApplianceId] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isActive, setLoaderActive] = useState(false);


  useEffect(() => {
    window.scrollTo(0, 0);
    getApliances();
  }, []);

  const getApliances = async (id) => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    setLoaderActive(true)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance`,
        {
          headers: headers,
        }
      );
      setLoaderActive(false)
      if (response.status === 400) {
        navigate("/login");
      }
      const tempdata = response.data.data;
      const ApplianceData = tempdata?.map((item, index) => {
        return { ...item, no: index + 1 };
      });
      setAppliance(ApplianceData);
    } catch (error) {
      setLoaderActive(false)
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  const openDeleteModal = (ApplianceDeleteId) => {
    setApplianceId(ApplianceDeleteId);
    setOpenModel(true);
  };
  const closeDeleteModal = (id) => {
    setApplianceId(id);

    setOpenModel(false);
  };

  const editappliance = (test) => {
    navigate(`/edit-appliances/${test?.applianceId}`)
  };

  const viewappliance = (test1) => {
    navigate(`/view-appliances/${test1?.applianceId}`);
  };

  const addappliances = () => {
    navigate("/add-appliances");
  };

  // Material Table Columns
  const columns = [
    { title: "No.", field: "no" },
    {
      title: "Images",
      field: "applianceImage",
      render: (rowData) => {
        return (
          <div>
            <img
              src={rowData?.applianceImage?.[0]?.applianceImage}
              alt={"logo"}
              style={{ height: "50px" }}
            />
          </div>
        );
      },
    },
    { title: "Appliance code", field: "applianceCode" },
    { title: "Brand name", field: "brandName" },
    {
      title: "Purchase date",
      field: "purchaseDate",
      render: (rowData) => {
        return moment(rowData?.purchaseDate).format("DD/MM/YYYY");
      },
    },
    { title: "Warrant period", field: "warrantPeriod" },
    { title: "Vendor name", field: "supplierName" },
    { title: "Vendor number", field: "supplierNumber" },
    {
      title: "Action",
      field: "action",
      render: (rowData) => (
        <span className="d-flex">
          <div
            // href="#"
            className="edit me-3"
            title="View"
            onClick={() => viewappliance(rowData)}
          >
            <VisibilityIcon color="primary" />
          </div>
          <div
            className="edit me-3"
            title="Edit"
            onClick={() => editappliance(rowData)}
          >
            <CreateIcon color="success" />
          </div>
        </span>
      ),
    },
  ];


  const defaultMaterialTheme = createTheme();
  return (
    <>
      <Loader isLoading={isActive} />
      <div className="management">
        <div className="main-wrapper">
          <main className="main-sec active">
            <Container fluid className="custom-padding">
              <div className="">
                <ThemeProvider theme={defaultMaterialTheme}>
                  <div className="aad-btn-wrap">
                    <button onClick={addappliances}>Add New Appliances</button>
                  </div>
                  <MaterialTable
                    title="Appliances"
                    options={{
                      selection: true,
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          selectedRow === rowData?.tableData?.id
                            ? "#F3F5F5"
                            : "#FFF",
                      }),
                      headerStyle: {
                        backgroundColor: "#E5F0FB",
                      },
                    }}
                    onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow?.tableData?.id)}
                    actions={[
                      {
                        tooltip: "Remove All Selected Users",
                        icon: "delete",
                        onClick: (evt, data) => {
                          let selectedAppliancedata = []
                          data?.map((dat) => selectedAppliancedata.push(dat.applianceId))
                          openDeleteModal(selectedAppliancedata);
                        },
                      },
                    ]}
                    columns={columns}
                    data={appliance}
                  />
                </ThemeProvider>
              </div>
            </Container>
            {openmodel && (
              <AppliancesDeleteModal
                applianceId={applianceid}
                open={openmodel}
                close={closeDeleteModal}
                getApliances={getApliances}
                setLoaderActive={setLoaderActive}
              />
            )}
          </main>
        </div>
      </div>
    </>
  );
}

export default Appliances;
